/**
 * @generated SignedSource<<9d04249a9e31ec3e3ff7656b28b92188>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type user_isMember$data = {
  readonly isMember: boolean;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentType": "user_isMember";
};
export type user_isMember$key = {
  readonly " $data"?: user_isMember$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_isMember">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "user_isMember"
};

(node as any).hash = "562f2767be1c8a557352ebc91e717708";

export default node;
